import React, { Component, Fragment, useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import { element } from 'prop-types';
import * as debounce from 'lodash.debounce';

const SubCategories = (props) => {
    const [open, setopen] = useState(false);
    const [menuElement, setmenuElement] = useState();
    const [overlayElem, setoverlayElem] = useState();               

        useEffect(() => {
            window.addEventListener('resize', submenuSetTopDebounce());
        }, []);
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.submenuSetTopDebounce);
    // }

    const submenuSetTopDebounce = debounce(() => submenuSetTop(), 200);
    

    const submenuSetTop = () => {
        if (!open && menuElement && overlayElem) {
            var offsetTop = menuElement.getBoundingClientRect().top;
            overlayElem.style.top = `${-offsetTop}px`;
            menuElement.style.top = `${-offsetTop}px`;
        }
    }

    const toggleOpen = () => {
        menuElement.style.top = `0px`;
        setopen(!open);        
        props.callback();
        submenuSetTop();
    };

    
        const { link } = props;
        const hasLinks = link.links && link.links.length > 0;
        return (
            <div className="sub-categories" >
                {hasLinks ? (
                    <Fragment>
                        <div className={`overlay-close ${open ? 'active' : ''}`} ref={(element) => setoverlayElem(element)} 
                        onClick={() => toggleOpen()}></div>
                        <div className="sub-categories__header sub-categories__header--has-menu" onClick={() => toggleOpen()}>
                            <div className="ti-submenu__image image-container">                                
                                <img src={link.attributes.imageUrl} alt={link.attributes.imageAlt}/>
                            </div>
                            {link.name}
                            <svg className="svg-arrow"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                        </div>
                        <div className={`sub-categories__menu ${open ? 'open' : ''}`} ref={(element) => setmenuElement(element)}>
                            <div className="ti-megamenu__close sub-categories__close" onClick={() => toggleOpen()}>
                                <svg>
                                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use>
                                </svg>
                            </div>
                            <ul className={`sub-categories__list`}>
                                <li className="sub-categories__top-image image-container">                                    
                                    <img src={link.attributes.imageUrl} alt={link.attributes.imageAlt}/>
                                </li>
                                {link.links && link.links.map((value, index) => {
                                    return <li key={index} className="sub-categories__link">
                                        <a href={value.url}>
                                            {value.name}
                                            <svg className="svg-arrow"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                                        </a>
                                    </li>
                                })}
                                <li className="sub-categories__all ti-menuitem">
                                    <a href={link.url}>
                                        {translate('common.all')} {link.name}
                                        <svg className="svg-arrow"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </Fragment>
                ) : (
                    <a className="sub-categories__header" href={link.url}>
                        {link.attributes && link.attributes.imageUrl && <div className="ti-submenu__image image-container">                            
                            <img src={link.attributes.imageUrl} alt={link.attributes.imageAlt}/>
                        </div>
                        }
                        {link.name}
                        <svg className="svg-arrow arrow-right"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                    </a>
                )
                }
            </div>
        );    
}

export default SubCategories;